
import Slider from "react-slick";
import { useContext } from 'react';
import { GlobalContext } from '../../_helpers/GlobalState';
import "./clients-modern.css";

function Clients() {
    const { WebsiteData } = useContext(GlobalContext);

    var settings = {
        dots: false,
        infinite: true,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        pauseOnHover: true,
        centerMode: false,
        cssEase: "ease-in-out",
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '60px',
                }
            }
        ]
    };

    return (
        <>
            {/* Modern Clientele Section */}
            <section className="modern-clients-section">
                <div className="clients-background">
                    <div className="clients-overlay"></div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">Trusted by Industry Leaders</span>
                                <h2 className="section-title">
                                    Our <span className="accent-text">Clientele</span>
                                </h2>
                                <p className="section-description">
                                    We're proud to work with some of the most innovative companies across various industries
                                </p>
                                <div className="section-divider"></div>
                            </div>
                        </div>
                    </div>
                    
               
                    {/* Client Logos Slider */}
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="clients-slider-container">
                                <h3 className="slider-title">Brands That Trust Us</h3>
                                <div className="clients-slider">
                                    <Slider {...settings}>
                                        {WebsiteData?.Website?.Clientele?.ClientImages?.map((client, index) => (
                                            <div className="client-logo-item" key={index}>
                                                <div className="logo-container">
                                                    <img src={client} alt={`Client ${index + 1}`} />
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Testimonial Quote */}
                    <div className="row mt-5">
                        <div className="col-lg-8 mx-auto">
                            <div className="client-testimonial">
                                <div className="testimonial-icon">
                                    <i className="fas fa-quote-left"></i>
                                </div>
                                <blockquote>
                                    "Working with RKG Technical Services has been an exceptional experience. Their professionalism, 
                                    attention to detail, and commitment to excellence make them our preferred partner for all technical services."
                                </blockquote>
                                <div className="testimonial-author">
                                    <div className="author-info">
                                        <h5>Industry Client</h5>
                                        <p>Leading Manufacturing Company</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                
                </div>
            </section>
        </>
    )
}

export default Clients;